import React from "react";
import { textTranslations } from "./footer/text-translations";
import { useLanguage } from "./LanguageContext";

const Footer = (props) => {

    const { language } = useLanguage();

    return (
        <footer className={props.fixed ? "footer fixed-footer" : "footer"}>
            <p>
            {textTranslations("main", language)}
            <div>
                <span className="pretty-link" onClick={() => window.open("/privacy-policy", "_self")}>{textTranslations("privacy-policy", language)}</span>
                <span className="pretty-link"> <a href="/blogs"> Blogs </a> </span>
                <span className="pretty-link" onClick={() => window.open("/terms-of-use", "_self")}>{textTranslations("terms-of-use", language)}</span>
            </div>
            </p>
        </footer>
    );
}

export default Footer;